/* eslint-disable */

import { replace } from 'New/article-detail/components/content'
export const emojiResourceList = {
  '[微笑]': {
    index: 1,
    name: '[微笑]',
    image: 'emoji_1_smile@3x.png',
    key: 'emoji_1_smile@3x.png',
    width: 96,
    height: 96,
  },
  '[爱慕]': {
    index: 2,
    name: '[爱慕]',
    image: 'emoji_2_kiss@3x.png',
    key: 'emoji_2_kiss@3x.png',
    width: 96,
    height: 96,
  },
  '[惊呆]': {
    index: 3,
    name: '[惊呆]',
    image: 'emoji_3_daze@3x.png',
    key: 'emoji_3_daze@3x.png',
    width: 96,
    height: 96,
  },
  '[酷拽]': {
    index: 4,
    name: '[酷拽]',
    image: 'emoji_4_smoke@3x.png',
    key: 'emoji_4_smoke@3x.png',
    width: 96,
    height: 96,
  },
  '[抠鼻]': {
    index: 5,
    name: '[抠鼻]',
    image: 'emoji_5_pick_nose@3x.png',
    key: 'emoji_5_pick_nose@3x.png',
    width: 96,
    height: 96,
  },
  '[流泪]': {
    index: 6,
    name: '[流泪]',
    image: 'emoji_6_cry@3x.png',
    key: 'emoji_6_cry@3x.png',
    width: 96,
    height: 96,
  },
  '[发怒]': {
    index: 7,
    name: '[发怒]',
    image: 'emoji_7_anger@3x.png',
    key: 'emoji_7_anger@3x.png',
    width: 96,
    height: 96,
  },
  '[呲牙]': {
    index: 8,
    name: '[呲牙]',
    image: 'emoji_8_laugh@3x.png',
    key: 'emoji_8_laugh@3x.png',
    width: 96,
    height: 96,
  },
  '[鼾睡]': {
    index: 9,
    name: '[鼾睡]',
    image: 'emoji_9_sleep@3x.png',
    key: 'emoji_9_sleep@3x.png',
    width: 96,
    height: 96,
  },
  '[害羞]': {
    index: 10,
    name: '[害羞]',
    image: 'emoji_10_shy@3x.png',
    key: 'emoji_10_shy@3x.png',
    width: 96,
    height: 96,
  },
  '[可爱]': {
    index: 11,
    name: '[可爱]',
    image: 'emoji_11_naughty@3x.png',
    key: 'emoji_11_naughty@3x.png',
    width: 102,
    height: 96,
  },
  '[晕]': {
    index: 12,
    name: '[晕]',
    image: 'emoji_12_dizzy@3x.png',
    key: 'emoji_12_dizzy@3x.png',
    width: 96,
    height: 96,
  },
  '[衰]': {
    index: 13,
    name: '[衰]',
    image: 'emoji_13_stunned@3x.png',
    key: 'emoji_13_stunned@3x.png',
    width: 96,
    height: 96,
  },
  '[闭嘴]': {
    index: 14,
    name: '[闭嘴]',
    image: 'emoji_14_shut_up@3x.png',
    key: 'emoji_14_shut_up@3x.png',
    width: 96,
    height: 96,
  },
  '[机智]': {
    index: 15,
    name: '[机智]',
    image: 'emoji_15_wit@3x.png',
    key: 'emoji_15_wit@3x.png',
    width: 96,
    height: 96,
  },
  '[来看我]': {
    index: 16,
    name: '[来看我]',
    image: 'emoji_16_attention@3x.png',
    key: 'emoji_16_attention@3x.png',
    width: 108,
    height: 96,
  },
  '[灵光一闪]': {
    index: 17,
    name: '[灵光一闪]',
    image: 'emoji_17_hand_sample@3x.png',
    key: 'emoji_17_hand_sample@3x.png',
    width: 102,
    height: 96,
  },
  '[耶]': {
    index: 18,
    name: '[耶]',
    image: 'emoji_18_ye@3x.png',
    key: 'emoji_18_ye@3x.png',
    width: 99,
    height: 96,
  },
  '[捂脸]': {
    index: 19,
    name: '[捂脸]',
    image: 'emoji_19_distress_situation@3x.png',
    key: 'emoji_19_distress_situation@3x.png',
    width: 96,
    height: 96,
  },
  '[打脸]': {
    index: 20,
    name: '[打脸]',
    image: 'emoji_20_play_face@3x.png',
    key: 'emoji_20_play_face@3x.png',
    width: 102,
    height: 96,
  },
  '[大笑]': {
    index: 21,
    name: '[大笑]',
    image: 'emoji_21_smile@3x.png',
    key: 'emoji_21_smile@3x.png',
    width: 96,
    height: 96,
  },
  '[哈欠]': {
    index: 22,
    name: '[哈欠]',
    image: 'emoji_22_yawn@3x.png',
    key: 'emoji_22_yawn@3x.png',
    width: 96,
    height: 96,
  },
  '[震惊]': {
    index: 23,
    name: '[震惊]',
    image: 'emoji_23_surprise@3x.png',
    key: 'emoji_23_surprise@3x.png',
    width: 96,
    height: 96,
  },
  '[送心]': {
    index: 24,
    name: '[送心]',
    image: 'emoji_24_take_heart@3x.png',
    key: 'emoji_24_take_heart@3x.png',
    width: 96,
    height: 96,
  },
  '[困]': {
    index: 25,
    name: '[困]',
    image: 'emoji_25_sleepy@3x.png',
    key: 'emoji_25_sleepy@3x.png',
    width: 96,
    height: 96,
  },
  '[what]': {
    index: 26,
    name: '[what]',
    image: 'emoji_26_what@3x.png',
    key: 'emoji_26_what@3x.png',
    width: 105,
    height: 96,
  },
  '[泣不成声]': {
    index: 27,
    name: '[泣不成声]',
    image: 'emoji_27_sobbing@3x.png',
    key: 'emoji_27_sobbing@3x.png',
    width: 96,
    height: 96,
  },
  '[小鼓掌]': {
    index: 28,
    name: '[小鼓掌]',
    image: 'emoji_28_handclap@3x.png',
    key: 'emoji_28_handclap@3x.png',
    width: 96,
    height: 96,
  },
  '[酷]': {
    index: 29,
    name: '[酷]',
    image: 'emoji_29_cool@3x.png',
    key: 'emoji_29_cool@3x.png',
    width: 96,
    height: 96,
  },
  '[大金牙]': {
    index: 29,
    name: '[大金牙]',
    image: 'emoji_29_cool@3x.png',
    key: 'emoji_29_cool@3x.png',
    width: 96,
    height: 96,
  },
  '[偷笑]': {
    index: 30,
    name: '[偷笑]',
    image: 'emoji_30_titter@3x.png',
    key: 'emoji_30_titter@3x.png',
    width: 96,
    height: 96,
  },
  '[石化]': {
    index: 31,
    name: '[石化]',
    image: 'emoji_31_lightning_strike@3x.png',
    key: 'emoji_31_lightning_strike@3x.png',
    width: 96,
    height: 96,
  },
  '[思考]': {
    index: 32,
    name: '[思考]',
    image: 'emoji_32_meditation@3x.png',
    key: 'emoji_32_meditation@3x.png',
    width: 96,
    height: 96,
  },
  '[吐血]': {
    index: 33,
    name: '[吐血]',
    image: 'emoji_33_vomiting_blood@3x.png',
    key: 'emoji_33_vomiting_blood@3x.png',
    width: 96,
    height: 96,
  },
  '[可怜]': {
    index: 34,
    name: '[可怜]',
    image: 'emoji_34_acting_cute@3x.png',
    key: 'emoji_34_acting_cute@3x.png',
    width: 96,
    height: 96,
  },
  '[嘘]': {
    index: 35,
    name: '[嘘]',
    image: 'emoji_35_quietly@3x.png',
    key: 'emoji_35_quietly@3x.png',
    width: 96,
    height: 96,
  },
  '[撇嘴]': {
    index: 36,
    name: '[撇嘴]',
    image: 'emoji_36_hum@3x.png',
    key: 'emoji_36_hum@3x.png',
    width: 96,
    height: 96,
  },
  '[黑线]': {
    index: 37,
    name: '[黑线]',
    image: 'emoji_37_khan@3x.png',
    key: 'emoji_37_khan@3x.png',
    width: 96,
    height: 96,
  },
  '[笑哭]': {
    index: 38,
    name: '[笑哭]',
    image: 'emoji_38_forced_smile@3x.png',
    key: 'emoji_38_forced_smile@3x.png',
    width: 111,
    height: 96,
  },
  '[雾霾]': {
    index: 39,
    name: '[雾霾]',
    image: 'emoji_39_haze@3x.png',
    key: 'emoji_39_haze@3x.png',
    width: 96,
    height: 96,
  },
  '[奸笑]': {
    index: 40,
    name: '[奸笑]',
    image: 'emoji_40_smirk@3x.png',
    key: 'emoji_40_smirk@3x.png',
    width: 96,
    height: 96,
  },
  '[得意]': {
    index: 41,
    name: '[得意]',
    image: 'emoji_41_cool@3x.png',
    key: 'emoji_41_cool@3x.png',
    width: 96,
    height: 96,
  },
  '[憨笑]': {
    index: 42,
    name: '[憨笑]',
    image: 'emoji_42_bad_smile@3x.png',
    key: 'emoji_42_bad_smile@3x.png',
    width: 96,
    height: 96,
  },
  '[抓狂]': {
    index: 43,
    name: '[抓狂]',
    image: 'emoji_43_crazy@3x.png',
    key: 'emoji_43_crazy@3x.png',
    width: 96,
    height: 96,
  },
  '[泪奔]': {
    index: 44,
    name: '[泪奔]',
    image: 'emoji_44_tears@3x.png',
    key: 'emoji_44_tears@3x.png',
    width: 96,
    height: 96,
  },
  '[钱]': {
    index: 45,
    name: '[钱]',
    image: 'emoji_45_money@3x.png',
    key: 'emoji_45_money@3x.png',
    width: 96,
    height: 96,
  },
  '[吻]': {
    index: 46,
    name: '[吻]',
    image: 'emoji_46_kiss@3x.png',
    key: 'emoji_46_kiss@3x.png',
    width: 96,
    height: 96,
  },
  '[恐惧]': {
    index: 47,
    name: '[恐惧]',
    image: 'emoji_47_fear@3x.png',
    key: 'emoji_47_fear@3x.png',
    width: 96,
    height: 96,
  },
  '[笑]': {
    index: 48,
    name: '[笑]',
    image: 'emoji_48_smile@3x.png',
    key: 'emoji_48_smile@3x.png',
    width: 96,
    height: 96,
  },
  '[快哭了]': {
    index: 49,
    name: '[快哭了]',
    image: 'emoji_49_injustice@3x.png',
    key: 'emoji_49_injustice@3x.png',
    width: 96,
    height: 96,
  },
  '[翻白眼]': {
    index: 50,
    name: '[翻白眼]',
    image: 'emoji_50_their@3x.png',
    key: 'emoji_50_their@3x.png',
    width: 96,
    height: 96,
  },
  '[互粉]': {
    index: 51,
    name: '[互粉]',
    image: 'emoji_51_focus@3x.png',
    key: 'emoji_51_focus@3x.png',
    width: 96,
    height: 96,
  },
  '[赞]': {
    index: 52,
    name: '[赞]',
    image: 'emoji_52_like@3x.png',
    key: 'emoji_52_like@3x.png',
    width: 96,
    height: 96,
  },
  '[鼓掌]': {
    index: 53,
    name: '[鼓掌]',
    image: 'emoji_53_handclap@3x.png',
    key: 'emoji_53_handclap@3x.png',
    width: 96,
    height: 96,
  },
  '[谢谢]': {
    index: 54,
    name: '[谢谢]',
    image: 'emoji_54_3Q@3x.png',
    key: 'emoji_54_3Q@3x.png',
    width: 96,
    height: 96,
  },
  '[祈祷]': {
    index: 54,
    name: '[祈祷]',
    image: 'emoji_54_3Q@3x.png',
    key: 'emoji_54_3Q@3x.png',
    width: 96,
    height: 96,
  },
  '[kiss]': {
    index: 55,
    name: '[kiss]',
    image: 'emoji_55_kiss@3x.png',
    key: 'emoji_55_kiss@3x.png',
    width: 96,
    height: 96,
  },
  '[去污粉]': {
    index: 56,
    name: '[去污粉]',
    image: 'emoji_56_household_cleanser@3x.png',
    key: 'emoji_56_household_cleanser@3x.png',
    width: 96,
    height: 96,
  },
  '[666]': {
    index: 57,
    name: '[666]',
    image: 'emoji_57_666@3x.png',
    key: 'emoji_57_666@3x.png',
    width: 96,
    height: 96,
  },
  '[玫瑰]': {
    index: 58,
    name: '[玫瑰]',
    image: 'emoji_58_rose@3x.png',
    key: 'emoji_58_rose@3x.png',
    width: 96,
    height: 96,
  },
  '[胡瓜]': {
    index: 59,
    name: '[胡瓜]',
    image: 'emoji_59_cucumber@3x.png',
    key: 'emoji_59_cucumber@3x.png',
    width: 96,
    height: 96,
  },
  '[啤酒]': {
    index: 60,
    name: '[啤酒]',
    image: 'emoji_60_beer@3x.png',
    key: 'emoji_60_beer@3x.png',
    width: 96,
    height: 96,
  },
  '[我想静静]': {
    index: 61,
    name: '[我想静静]',
    image: 'emoji_61_distress_situation@3x.png',
    key: 'emoji_61_distress_situation@3x.png',
    width: 105,
    height: 96,
  },
  '[委屈]': {
    index: 62,
    name: '[委屈]',
    image: 'emoji_62_injustice@3x.png',
    key: 'emoji_62_injustice@3x.png',
    width: 96,
    height: 96,
  },
  '[舔屏]': {
    index: 63,
    name: '[舔屏]',
    image: 'emoji_63_lick_screen@3x.png',
    key: 'emoji_63_lick_screen@3x.png',
    width: 96,
    height: 96,
  },
  '[鄙视]': {
    index: 64,
    name: '[鄙视]',
    image: 'emoji_64_despise@3x.png',
    key: 'emoji_64_despise@3x.png',
    width: 96,
    height: 96,
  },
  '[飞吻]': {
    index: 65,
    name: '[飞吻]',
    image: 'emoji_65_kiss@3x.png',
    key: 'emoji_65_kiss@3x.png',
    width: 96,
    height: 96,
  },
  '[再见]': {
    index: 66,
    name: '[再见]',
    image: 'emoji_66_bye@3x.png',
    key: 'emoji_66_bye@3x.png',
    width: 96,
    height: 96,
  },
  '[紫薇别走]': {
    index: 67,
    name: '[紫薇别走]',
    image: 'emoji_67_erkang@3x.png',
    key: 'emoji_67_erkang@3x.png',
    width: 108,
    height: 96,
  },
  '[求抱抱]': {
    index: 68,
    name: '[求抱抱]',
    image: 'emoji_68_hug@3x.png',
    key: 'emoji_68_hug@3x.png',
    width: 108,
    height: 96,
  },
  '[听歌]': {
    index: 69,
    name: '[听歌]',
    image: 'emoji_69_hitler@3x.png',
    key: 'emoji_69_hitler@3x.png',
    width: 96,
    height: 96,
  },
  '[周冬雨的凝视]': {
    index: 70,
    name: '[周冬雨的凝视]',
    image: 'emoji_70_zhoudongyu_gaze@3x.png',
    key: 'emoji_70_zhoudongyu_gaze@3x.png',
    width: 96,
    height: 96,
  },
  '[马思纯的微笑]': {
    index: 71,
    name: '[马思纯的微笑]',
    image: 'emoji_71_masichun_smile@3x.png',
    key: 'emoji_71_masichun_smile@3x.png',
    width: 96,
    height: 96,
  },
  '[吐舌]': {
    index: 72,
    name: '[吐舌]',
    image: 'emoji_72_dogo@3x.png',
    key: 'emoji_72_dogo@3x.png',
    width: 96,
    height: 96,
  },
  '[呆无辜]': {
    index: 73,
    name: '[呆无辜]',
    image: 'emoji_73_cat@3x.png',
    key: 'emoji_73_cat@3x.png',
    width: 96,
    height: 96,
  },
  '[看]': {
    index: 74,
    name: '[看]',
    image: 'emoji_74_2ha@3x.png',
    key: 'emoji_74_2ha@3x.png',
    width: 96,
    height: 96,
  },
  '[白眼]': {
    index: 75,
    name: '[白眼]',
    image: 'emoji_75_dogo@3x.png',
    key: 'emoji_75_dogo@3x.png',
    width: 96,
    height: 96,
  },
  '[熊吉]': {
    index: 76,
    name: '[熊吉]',
    image: 'emoji_76_bear@3x.png',
    key: 'emoji_76_bear@3x.png',
    width: 96,
    height: 96,
  },
  '[骷髅]': {
    index: 77,
    name: '[骷髅]',
    image: 'emoji_77_skeleton@3x.png',
    key: 'emoji_77_skeleton@3x.png',
    width: 96,
    height: 96,
  },
  '[黑脸]': {
    index: 78,
    name: '[黑脸]',
    image: 'emoji_78_black_face@3x.png',
    key: 'emoji_78_black_face@3x.png',
    width: 96,
    height: 96,
  },
  '[吃瓜群众]': {
    index: 79,
    name: '[吃瓜群众]',
    image: 'emoji_79_eat_melon@3x.png',
    key: 'emoji_79_eat_melon@3x.png',
    width: 96,
    height: 96,
  },
  '[绿帽子]': {
    index: 80,
    name: '[绿帽子]',
    image: 'emoji_80_green_hat@3x.png',
    key: 'emoji_80_green_hat@3x.png',
    width: 96,
    height: 96,
  },
  '[汗]': {
    index: 81,
    name: '[汗]',
    image: 'emoji_81_sweat@3x.png',
    key: 'emoji_81_sweat@3x.png',
    width: 96,
    height: 96,
  },
  '[摸头]': {
    index: 82,
    name: '[摸头]',
    image: 'emoji_82_lear_ropes@3x.png',
    key: 'emoji_82_lear_ropes@3x.png',
    width: 96,
    height: 96,
  },
  '[皱眉]': {
    index: 83,
    name: '[皱眉]',
    image: 'emoji_83_frown@3x.png',
    key: 'emoji_83_frown@3x.png',
    width: 96,
    height: 96,
  },
  '[擦汗]': {
    index: 84,
    name: '[擦汗]',
    image: 'emoji_84_wipe_sweat@3x.png',
    key: 'emoji_84_wipe_sweat@3x.png',
    width: 96,
    height: 96,
  },
  '[红脸]': {
    index: 85,
    name: '[红脸]',
    image: 'emoji_85_redface@3x.png',
    key: 'emoji_85_redface@3x.png',
    width: 96,
    height: 96,
  },
  '[尬笑]': {
    index: 86,
    name: '[尬笑]',
    image: 'emoji_86_orz@3x.png',
    key: 'emoji_86_orz@3x.png',
    width: 96,
    height: 96,
  },
  '[做鬼脸]': {
    index: 87,
    name: '[做鬼脸]',
    image: 'emoji_87_makeface@3x.png',
    key: 'emoji_87_makeface@3x.png',
    width: 96,
    height: 96,
  },
  '[强]': {
    index: 88,
    name: '[强]',
    image: 'emoji_88_intensity@3x.png',
    key: 'emoji_88_intensity@3x.png',
    width: 96,
    height: 96,
  },
  '[如花]': {
    index: 89,
    name: '[如花]',
    image: 'emoji_89_ruhua@3x.png',
    key: 'emoji_89_ruhua@3x.png',
    width: 96,
    height: 96,
  },
  '[吐]': {
    index: 90,
    name: '[吐]',
    image: 'emoji_90_spit@3x.png',
    key: 'emoji_90_spit@3x.png',
    width: 96,
    height: 96,
  },
  '[惊喜]': {
    index: 91,
    name: '[惊喜]',
    image: 'emoji_91_surprise@3x.png',
    key: 'emoji_91_surprise@3x.png',
    width: 96,
    height: 96,
  },
  '[敲打]': {
    index: 92,
    name: '[敲打]',
    image: 'emoji_92_knock@3x.png',
    key: 'emoji_92_knock@3x.png',
    width: 96,
    height: 96,
  },
  '[奋斗]': {
    index: 93,
    name: '[奋斗]',
    image: 'emoji_93_refuel@3x.png',
    key: 'emoji_93_refuel@3x.png',
    width: 96,
    height: 96,
  },
  '[吐彩虹]': {
    index: 94,
    name: '[吐彩虹]',
    image: 'emoji_94_rainbow@3x.png',
    key: 'emoji_94_rainbow@3x.png',
    width: 96,
    height: 96,
  },
  '[大哭]': {
    index: 95,
    name: '[大哭]',
    image: 'emoji_95_bigcry@3x.png',
    key: 'emoji_95_bigcry@3x.png',
    width: 96,
    height: 96,
  },
  '[比心]': {
    index: 96,
    name: '[比心]',
    image: 'emoji_96_fingerheart@3x.png',
    key: 'emoji_96_fingerheart@3x.png',
    width: 96,
    height: 96,
  },
  '[加油]': {
    index: 97,
    name: '[加油]',
    image: 'emoji_97_refuel@3x.png',
    key: 'emoji_97_refuel@3x.png',
    width: 96,
    height: 96,
  },
  '[碰拳]': {
    index: 98,
    name: '[碰拳]',
    image: 'emoji_98_fist@3x.png',
    key: 'emoji_98_fist@3x.png',
    width: 96,
    height: 96,
  },
  '[ok]': {
    index: 99,
    name: '[ok]',
    image: 'emoji_99_OK@3x.png',
    key: 'emoji_99_OK@3x.png',
    width: 96,
    height: 96,
  },
  '[击掌]': {
    index: 100,
    name: '[击掌]',
    image: 'emoji_100_highfive@3x.png',
    key: 'emoji_100_highfive@3x.png',
    width: 96,
    height: 96,
  },
  '[左上]': {
    index: 101,
    name: '[左上]',
    image: 'emoji_101_left@3x.png',
    key: 'emoji_101_left@3x.png',
    width: 96,
    height: 96,
  },
  '[握手]': {
    index: 102,
    name: '[握手]',
    image: 'emoji_102_shakehand@3x.png',
    key: 'emoji_102_shakehand@3x.png',
    width: 96,
    height: 96,
  },
  '[18禁]': {
    index: 103,
    name: '[18禁]',
    image: 'emoji_103_18@3x.png',
    key: 'emoji_103_18@3x.png',
    width: 96,
    height: 96,
  },
  '[刀]': {
    index: 104,
    name: '[刀]',
    image: 'emoji_104_knife@3x.png',
    key: 'emoji_104_knife@3x.png',
    width: 96,
    height: 96,
  },
  '[V5]': {
    index: 105,
    name: '[V5]',
    image: 'emoji_105_V5@3x.png',
    key: 'emoji_105_V5@3x.png',
    width: 96,
    height: 96,
  },
  '[给力]': {
    index: 106,
    name: '[给力]',
    image: 'emoji_106_awesome@3x.png',
    key: 'emoji_106_awesome@3x.png',
    width: 96,
    height: 96,
  },
  '[心]': {
    index: 107,
    name: '[心]',
    image: 'emoji_107_heart@3x.png',
    key: 'emoji_107_heart@3x.png',
    width: 96,
    height: 96,
  },
  '[伤心]': {
    index: 108,
    name: '[伤心]',
    image: 'emoji_108_broken_heart@3x.png',
    key: 'emoji_108_broken_heart@3x.png',
    width: 96,
    height: 96,
  },
  '[屎]': {
    index: 109,
    name: '[屎]',
    image: 'emoji_109_shit@3x.png',
    key: 'emoji_109_shit@3x.png',
    width: 96,
    height: 96,
  },
  '[礼物]': {
    index: 110,
    name: '[礼物]',
    image: 'emoji_110_gifts@3x.png',
    key: 'emoji_110_gifts@3x.png',
    width: 96,
    height: 96,
  },
  '[蛋糕]': {
    index: 111,
    name: '[蛋糕]',
    image: 'emoji_111_cake@3x.png',
    key: 'emoji_111_cake@3x.png',
    width: 96,
    height: 96,
  },
  '[撒花]': {
    index: 112,
    name: '[撒花]',
    image: 'emoji_112_flower@3x.png',
    key: 'emoji_112_flower@3x.png',
    width: 96,
    height: 96,
  },
  '[不看]': {
    index: 113,
    name: '[不看]',
    image: 'emoji_113_lookat@3x.png',
    key: 'emoji_113_lookat@3x.png',
    width: 96,
    height: 96,
  },
  '[炸弹]': {
    index: 114,
    name: '[炸弹]',
    image: 'emoji_114_bomb@3x.png',
    key: 'emoji_114_bomb@3x.png',
    width: 96,
    height: 96,
  },
} as {
  [key: string]: {
    index: number
    name: string
    image: string
    key: string
    width: number
    height: number
  }
}

export const emojiOrigin =
  '//lf3-cdn-tos.bytegoofy.com/goofy/toutiao/tt_tps/static/images/ttemoji_v2/'

export const emoji = (string: string) => {
  const reUnescapedHtml = /(\[[^\]]+[\]])+?/g
  const reHasUnescapedHtml = RegExp(reUnescapedHtml.source)
  return string && reHasUnescapedHtml.test(string)
    ? string.replace(reUnescapedHtml, (chr) => {
        if (emojiResourceList[chr]) {
          return `<i class="emoji" style="background-image:url(${emojiOrigin}${emojiResourceList[chr].image})"></i>`
        }
        return chr
      })
    : string
}

// 输入法 unicode 表情
const emojiUnicodeRegex =
  '(?:\ud83c[\udf00-\udfff])|(?:\ud83d[\udc00-\ude4f\ude80-\udeff])|[\u2600-\u2B55]'

const emojiPrivateRegex = Object.keys(emojiResourceList)
  .map((d) => d.replace('[', '\\[').replace(']', '\\]'))
  .join('|')

const emojiRegex = new RegExp(`(${emojiPrivateRegex}|${emojiUnicodeRegex})`)

export const filterEmoji = (string: string) => {
  if (!string) return ''
  return replace(string, emojiRegex, () => '')
}
